import { apiGet, apiPost } from "../../utils"

export function fetchMusicLinksAdminAPI(data) {
    return apiPost(`/api/fetchMusicLinksAdmin`, data)
}

export function getMusicLinksAdminAPI(data) {
    return apiGet(`/api/getMusicLinksAdmin`, data)
}

export function getMusilinksHistoryAdminAPI(data) {
    return apiGet(`/api/getMusilinksHistoryAdmin`, data)
}

export function getMusilinksSearchLogAdminAPI(data) {
    return apiGet(`/api/getMusilinksSearchLogAdmin`, data)
}

export function getLogosAPI() {
    return apiGet(`/api/getLogos`)
}
